import { ensureActive17z6c489wymmv as ensureActive } from './Emitters.mjs';
import { cancelConsumed2i0oizqhmljf6 as cancelConsumed } from '../channels/Channels.common.mjs';
import { Unit_instancev9v8hjid95df as Unit_instance } from '../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function *emitAll(_this__u8e3s4, channel, $completion) {
  return yield* emitAllImpl(_this__u8e3s4, channel, true, $completion);
}
function *emitAllImpl(_this__u8e3s4, channel, consume, $completion) {
  ensureActive(_this__u8e3s4);
  var cause = null;
  try {
    var _iterator__ex2g4s = channel.p1();
    while (yield* _iterator__ex2g4s.p1a($completion)) {
      var element = _iterator__ex2g4s.r1();
      yield* _this__u8e3s4.r1d(element, $completion);
    }
  } catch ($p) {
    if ($p instanceof Error) {
      var e = $p;
      cause = e;
      throw e;
    } else {
      throw $p;
    }
  }
  finally {
    if (consume) {
      cancelConsumed(channel, cause);
    }
  }
  return Unit_instance;
}
//region block: exports
export {
  emitAll as emitAll233y0vrwmloef,
};
//endregion

//# sourceMappingURL=Channels.mjs.map
